import React from 'react';
import { FiArrowRight, FiAlertCircle } from 'react-icons/fi';
import { LuFileSpreadsheet } from 'react-icons/lu';

const GuidanceWidgets = () => {

  const handleViewSOP = () => {
    console.log("Opening standard operating procedures document...");
  };

  const handleLogIncident = () => {
    console.log("Opening incident logging workflow wizard...");
  };

  return (
    <div className="w-full flex flex-col gap-4 font-sans select-none">
      
      {/* 1. Top Guidance Widget Box */}
      <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm flex flex-col">
        <h3 className="text-sm font-bold text-slate-900">
          Guidance
        </h3>
        
        {/* Core descriptions paragraph cluster strings */}
        <div className="text-[11px] text-slate-500 font-medium leading-relaxed flex flex-col gap-3.5 mt-3 mb-5">
          <p>
            This check should be completed at the start of every trading day before opening the restaurant.
          </p>
          <p>
            If you find any issues, log an incident immediately and take the necessary action.
          </p>
        </div>

        {/* View Opening SOP Form Action Button */}
        <button 
          type="button"
          onClick={handleViewSOP}
          className="w-full border border-slate-200 hover:border-indigo-600 bg-white font-bold text-xs py-2.5 px-4 rounded-xl shadow-sm text-indigo-600 transition-colors flex items-center justify-center gap-1.5"
        >
          <LuFileSpreadsheet className="text-sm" />
          <span>View Opening SOP</span>
        </button>
      </div>


      {/* 2. Bottom Important Notice Alert Box */}
      <div className="bg-amber-50/40 border border-amber-100/70 rounded-2xl p-5 shadow-sm flex flex-col">
        
        {/* Important Warning Icon Title Row */}
        <div className="flex items-center gap-2 text-amber-700">
          <FiAlertCircle className="text-base shrink-0" />
          <h3 className="text-sm font-bold tracking-wide">
            Important
          </h3>
        </div>

        {/* Informative alert notification text blocks */}
        <div className="text-[11px] text-amber-900/80 font-semibold leading-relaxed flex flex-col gap-3.5 mt-3 mb-5">
          <p>
            All issues must be resolved before trading.
          </p>
          <p>
            If you cannot resolve an issue, log an incident and inform your manager.
          </p>
        </div>

        {/* Log Incident Action Trigger Button Link */}
        <button 
          type="button"
          onClick={handleLogIncident}
          className="w-full border border-amber-200/60 bg-white/80 hover:bg-white text-indigo-600 font-bold text-xs py-2.5 px-4 rounded-xl shadow-sm transition-all flex items-center justify-center gap-1.5 group"
        >
          <span>Log Incident</span>
          <FiArrowRight className="text-sm transition-transform group-hover:translate-x-0.5 mt-0.5" />
        </button>
      </div>

    </div>
  );
};

export default GuidanceWidgets;
